module.exports = __webpack_public_path__ + "static/media/wrong.4e352c03.mp3";